import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/home.scss';
import './styles/nav.scss';
import './styles/media.scss';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

